import React from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'next/link';
import queryString from 'query-string';
import { Box, Link } from '@qga/roo-ui/components';
import { scrollTop } from 'lib/browser';

const NextLink = ({ page, pathname, currentQuery, pageSize, total, onClick }) => {
  const newQuery = { ...currentQuery, page: page + 1 };
  const offset = page * pageSize - pageSize;
  const showLink = offset + pageSize < total;
  const linkTo = { pathname, search: queryString.stringify(newQuery) };

  const handleOnClick = () => {
    onClick(newQuery.page);
    scrollTop();
  };

  return (
    <Box>
      {showLink && (
        <RouterLink href={`${linkTo.pathname}?${linkTo.search}`} passHref shallow>
          <Link underline color="greys.charcoal" px={3} py={1} data-testid="next-link" onClick={handleOnClick} role="link">
            Next
          </Link>
        </RouterLink>
      )}
    </Box>
  );
};

NextLink.propTypes = {
  page: PropTypes.number.isRequired,
  pathname: PropTypes.string.isRequired,
  currentQuery: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

NextLink.defaultProps = {
  onClick: () => {},
};

export default NextLink;
